/* src/app/user-default/handbook/handbook.component.scss */
iframe {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border: 0;
  height: 2000px;
}
/*# sourceMappingURL=handbook.component-YIGNSJUJ.css.map */
